 
document.addEventListener("DOMContentLoaded", function () {
  const checkbox = document.getElementById("accept-terms");
  const checkoutBtn = document.querySelector('button[name="checkout"], button.cart__checkout-button');
  const errorMsg = document.getElementById("terms-error");

  if (checkoutBtn && checkbox) {
    console.log('checked');
    checkoutBtn.disabled = true;

    checkbox.addEventListener("change", function () {
      if (checkbox.checked) {
        checkoutBtn.disabled = false;
        errorMsg.style.display = "none";
      } else {
        checkoutBtn.disabled = true;
      }
    });

  } else {
    if(checkoutBtn) {
      checkoutBtn.addEventListener("click", function (e) {
        if (!checkbox.checked) {
          e.preventDefault();
          errorMsg.style.display = "block";
        }
      });
    }
  }
});
    

    
      function addDrawerTermsValidation() {
        const drawerCheckbox = document.getElementById("drawer-accept-terms");
        const drawerCheckoutBtn = document.getElementById("CartDrawer-Checkout");
        const drawerErrorMsg = document.getElementById("drawer-terms-error");

        if (drawerCheckbox && drawerCheckoutBtn && drawerErrorMsg) {
          if (drawerCheckoutBtn.dataset.termsHandlerAttached === "true") return;

          drawerCheckoutBtn.disabled = true;

          drawerCheckbox.addEventListener("change", function () {
            if (drawerCheckbox.checked) {
              drawerCheckoutBtn.disabled = false;
              drawerErrorMsg.style.display = "none";
            } else {
              drawerCheckoutBtn.disabled = true;
            }
          });

          drawerCheckoutBtn.addEventListener("click", function (e) {
            if (!drawerCheckbox.checked) {
              e.preventDefault();
              drawerErrorMsg.style.display = "block";
            }
          });

          drawerCheckoutBtn.dataset.termsHandlerAttached = "true";
        }
      }

      function addCartPageTermsValidation() {
        const cartCheckbox = document.getElementById("accept-terms");
        const cartCheckoutBtn = document.querySelector('form[action$="/cart"] button[name="checkout"]');
        const cartErrorMsg = document.getElementById("terms-error");

        if (cartCheckbox && cartCheckoutBtn && cartErrorMsg) {
          if (cartCheckoutBtn.dataset.termsHandlerAttached === "true") return;

          cartCheckoutBtn.disabled = true;

          cartCheckbox.addEventListener("change", function () {
            if (cartCheckbox.checked) {
              cartCheckoutBtn.disabled = false;
              cartErrorMsg.classList.remove("show");
            } else {
              cartCheckoutBtn.disabled = true;
            }
          });

          cartCheckoutBtn.addEventListener("click", function (e) {
            if (!cartCheckbox.checked) {
              e.preventDefault();
              cartErrorMsg.classList.add("show");
            }
          });

          cartCheckoutBtn.dataset.termsHandlerAttached = "true";
        }
      }

      // Observa el drawer cuando aparezca
      function waitForDrawerAndObserve() {
        const checkDrawerInterval = setInterval(() => {
          const drawer = document.getElementById("CartDrawer");
          if (drawer) {
            console.log("✅ Drawer encontrado, inicializando observador...");
            clearInterval(checkDrawerInterval);

            const observer = new MutationObserver(() => {
              addDrawerTermsValidation();
            });

            observer.observe(drawer, { childList: true, subtree: true });

            // Ejecuta una vez por si ya está cargado
            addDrawerTermsValidation();
          } else {
            //console.log("⏳ Esperando a que CartDrawer aparezca...");
          }
        }, 3000); // revisa cada 300ms
      }

      // Inicia todo
      document.addEventListener("DOMContentLoaded", function () {
        waitForDrawerAndObserve();
        addCartPageTermsValidation();
      });
    
/*
    <script>
  document.addEventListener("DOMContentLoaded", function() {
    const isParentCheckbox = document.getElementById('is-parent');
    const babyDobInput = document.getElementById('baby-dob');
    const form = document.querySelector('form.customer-register'); // Ajusta si es necesario
    const errorMsg = document.getElementById('baby-dob-error');

    // Función para calcular fecha máxima: hoy menos 9 meses
    function setMaxDate() {
      const today = new Date();
      // Restar 9 meses
      const maxDate = new Date(today.getFullYear(), today.getMonth() + 9, today.getDate());
      // Formatear a YYYY-MM-DD
      const year = maxDate.getFullYear();
      const month = String(maxDate.getMonth() + 1).padStart(2, '0');
      const day = String(maxDate.getDate()).padStart(2, '0');
      babyDobInput.max = `${year}-${month}-${day}`;
    }

    setMaxDate();

    // Habilita/deshabilita fecha bebé según checkbox
    isParentCheckbox.addEventListener('change', function() {
      if (this.checked) {
        babyDobInput.disabled = false;
      } else {
        babyDobInput.disabled = true;
        babyDobInput.value = '';
        errorMsg.style.display = 'none';
      }
    });

    // Validación al enviar formulario
    form.addEventListener('submit', function(e) {
      if (isParentCheckbox.checked) {
        if (!babyDobInput.value) {
          e.preventDefault();
          errorMsg.textContent = 'Por favor ingresa la fecha de nacimiento del bebé.';
          errorMsg.style.display = 'block';
          babyDobInput.focus();
          return;
        }
        if (babyDobInput.value > babyDobInput.max) {
          e.preventDefault();
          errorMsg.textContent = `La fecha no puede ser más reciente que ${babyDobInput.max}.`;
          errorMsg.style.display = 'block';
          babyDobInput.focus();
          return;
        }
      }
    });
  });
</script>

<script>
      function addDrawerTermsValidation() {
        const drawerCheckbox = document.getElementById("drawer-accept-terms");
        const drawerCheckoutBtn = document.getElementById("CartDrawer-Checkout");
        const drawerErrorMsg = document.getElementById("drawer-terms-error");

        console.log("Ejecutando validación del drawer...");
        console.log("Checkbox:", drawerCheckbox);
        console.log("Botón checkout:", drawerCheckoutBtn);
        console.log("Mensaje de error:", drawerErrorMsg);

        if (drawerCheckbox && drawerCheckoutBtn && drawerErrorMsg) {
          drawerCheckoutBtn.disabled = true;

          drawerCheckbox.addEventListener("change", function () {
            if (drawerCheckbox.checked) {
              drawerCheckoutBtn.disabled = false;
              drawerErrorMsg.classList.remove("show");
            } else {
              drawerCheckoutBtn.disabled = true;
            }
          });

          drawerCheckoutBtn.addEventListener("click", function (e) {
            if (!drawerCheckbox.checked) {
              e.preventDefault();
              drawerErrorMsg.classList.add("show");
            }
          });
        }
      }

      // Observa el drawer por cambios
      document.addEventListener("DOMContentLoaded", function () {
        const drawer = document.getElementById("CartDrawer-Overlay");
        console.log('drawer', drawer);

        if (!drawer) return;

        const observer = new MutationObserver((mutationsList, observer) => {
          for (const mutation of mutationsList) {
            if (mutation.type === "childList") {
              // Vuelve a ejecutar el script cuando cambie el contenido del drawer
              addDrawerTermsValidation();
            }
          }
        });

        observer.observe(drawer, { childList: true, subtree: true });
      });
    </script>
    */


function validarCedulaEcuatoriana(cedula) {
  if (!/^\d{10}$/.test(cedula)) return false;
  const provincia = parseInt(cedula.substring(0, 2), 10);
  if (provincia < 1 || provincia > 24) return false;

  const digitos = cedula.split('').map(Number);
  const verificador = digitos.pop();

  let suma = 0;
  for (let i = 0; i < digitos.length; i++) {
    let valor = digitos[i];
    if (i % 2 === 0) {
      valor *= 2;
      if (valor > 9) valor -= 9;
    }
    suma += valor;
  }
  const decenaSuperior = Math.ceil(suma / 10) * 10;
  const digitoCalculado = decenaSuperior - suma === 10 ? 0 : decenaSuperior - suma;

  return digitoCalculado === verificador;
}
